import React from 'react';
import { Button } from 'nike-ui/src/components/button/Button';

import { navigate } from '@/routing';
import { COMMUNITY_NEW_TICKET_FROM_TICKET_HASH } from '@/routing/routes';
import AddIcon from 'nike-ui/src/icons/svg/add-icon-sv.svg';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';

function AddToBetbook({ ticket }) {
    function goToBetbookEditor() {
        PopupNg.dispatcher.close('betbook/ticketDetailPopup');
        PopupNg.dispatcher.close('ticketDetail');
        navigate(COMMUNITY_NEW_TICKET_FROM_TICKET_HASH, { ticketHash: ticket.hash });
    }
    return (
        <Button
            className="blue"
            dataAtid="ticket-detail-add-to-betbook"
            icon={AddIcon}
            label={i18n('betbook.createPost')}
            onClick={goToBetbookEditor}
        />
    );
}

export default AddToBetbook;
